import { React, useEffect } from "react";
import { useGlobalContext } from "../context";
import Board from "./Board";

const TrainingBoard = ({ chess }) => {
  const { setPgn, setFen, setIsGameOver, setLetRedo, setBoardOrientation } =
    useGlobalContext();

  useEffect(() => {
    chess.reset();
    setBoardOrientation("white");
  }, []);

  const setFenAndPgn = () => {
    setLetRedo(false);
    setFen(chess.fen());
    setPgn(chess.pgn());
  };

  const handleMove = (from, to) => {
    if (chess.move({ from, to, promotion: "q" })) {
      setFenAndPgn();

      if (chess.game_over()) {
        setIsGameOver(true);
      }
    }
  };

  // show valid moves for current color
  const calcMovable = () => {
    const dests = new Map();
    chess.SQUARES.forEach((s) => {
      const ms = chess.moves({ square: s, verbose: true });
      if (ms.length)
        dests.set(
          s,
          ms.map((m) => m.to)
        );
    });
    return {
      free: false,
      dests,
      color: chess.turn() === "w" ? "white" : "black",
    };
  };

  return (
    <>
      <Board chess={chess} handleMove={handleMove} calcMovable={calcMovable} />
    </>
  );
};

export default TrainingBoard;
